import { useTranslation } from "../../../../language";

export default function InvoicesText() {
  const { t } = useTranslation();
  return <span>{t("invoices_subtext")}</span>;
}
